import api from '@/plugins/api';

export const users = {
  load: async function (filters) {
    try {
      const response = await api.get('/businesses', {
        params: filters
      })
      return response.data
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  list: async function () {
    try {
      const response = await api.get('/businesses/list')
      return response.data
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  details: async function (id) {
    try {
      const response = await api.get(`/businesses/${id}`)
      return response.data
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  create: async function (data) {
    try {
      const response = await api.post('/businesses', data)
      return response.data
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  update: async function (id, data) {
    try {
      const response = await api.patch(`/businesses/${id}`, data)
      return response.data
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  remove: async function (id) {
    try {
      await api.delete(`/businesses/${id}`)
      return true
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
}

export default users
